export class Scheduling {
    date: string;
    period: number;
}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/shared/models/payment/scheduling.ts